import { DriverRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * saveDriverByCustomer - Function that saves on database a new driver by department  
 * /drivers  
 * method POST  
 * @async-function
 */
const saveDriverByCustomer = async (token: string, model: DriverRequestType) => {
    const response = await api.post(
        `/drivers`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default saveDriverByCustomer;